angular.module('picmonic-common')
    .filter('ucwords', function () {
        return function (input){
            return input.ucwords;
        }
    });